import type { PageLinkFragment } from '#gql';

export function useInternalRoute(
  link: PageLinkFragment | null | undefined | {},
) {
  const { locale } = useI18n();

  const path = computed(function () {
    if (!link || !('__typename' in link)) {
      return '/';
    }

    let linkBase = '/';

    if (locale.value !== 'de') {
      linkBase += `${locale.value}/`;
    }

    const translatedSlug =
      link._allSlugLocales?.find((it) => it.locale === locale.value)?.value ??
      null;

    return `${linkBase}${translatedSlug}`;
  });

  return { path };
}
